module.exports = __webpack_public_path__ + "static/media/atendimento-4-mobile.31ef0d3c.png";